<div class="instance-fill-page">
  <div class="page-header">
    <div class="page-header__title">
      <h2 id="instance-fill-title">{{ 'Instance fill' | translate }}</h2>
      <p>{{ 'Data this published instance needs before processes do useful work' | translate }}</p>
    </div>
    <div class="page-header__search">
      <app-orchestration-catalog-search [(query)]="searchQuery"></app-orchestration-catalog-search>
    </div>
    <div class="header-actions">
      <app-secondary-button class="header-actions__refresh" title="Refresh" icon="refresh" (action)="refresh()"></app-secondary-button>
    </div>
  </div>

  @if (loading() && !snapshot()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (errorMessage() && !snapshot()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  } @else {
    <section class="fill-summary" [attr.aria-label]="'Total records' | translate">
      <div class="fill-summary__stat">
        <span class="fill-summary__label">{{ 'Total records' | translate }}</span>
        <span class="fill-summary__value">{{ totals().recordCount }}</span>
      </div>
      @if (totals().hasActiveCount) {
        <div class="fill-summary__stat">
          <span class="fill-summary__label">{{ 'Active' | translate }}</span>
          <span class="fill-summary__value">{{ totals().activeCount }}</span>
        </div>
      }
      <div class="fill-summary__stat">
        <span class="fill-summary__label">{{ 'Filled' | translate }}</span>
        <span class="fill-summary__value">{{ totals().filledSteps }}</span>
      </div>
      <div class="fill-summary__stat">
        <span class="fill-summary__label">{{ 'Empty' | translate }}</span>
        <span class="fill-summary__value">{{ totals().emptySteps }}</span>
      </div>
      <div class="fill-summary__stat">
        <span class="fill-summary__label">{{ 'Unavailable' | translate }}</span>
        <span class="fill-summary__value">{{ totals().unavailableSteps }}</span>
      </div>
    </section>
    <div class="fill-charts">
      <section class="fill-charts__panel">
        <h3>{{ 'Record counts by step' | translate }}</h3>
        <msf-p-chart
          chartType="bar"
          [chartData]="countChartData()"
          [config]="countChartConfig"
          [showLegend]="false"
          [noDataMessage]="'No countable fill steps' | translate"
        ></msf-p-chart>
      </section>
      <section class="fill-charts__panel">
        <h3>{{ 'Step status mix' | translate }}</h3>
        <msf-p-chart
          chartType="doughnut"
          [chartData]="statusChartData()"
          [config]="statusChartConfig"
          [noDataMessage]="'No countable fill steps' | translate"
        ></msf-p-chart>
      </section>
    </div>
    @if (visibleCards().length === 0) {
      <p class="empty-search">{{ 'No catalog matches' | translate }}</p>
    } @else {
      <ul class="step-grid" aria-labelledby="instance-fill-title">
        @for (card of visibleCards(); track card.id) {
          <li class="step-card" [attr.data-fill-status]="card.status">
            <div class="step-card__head">
              <h3>{{ card.titleKey | translate }}</h3>
              <app-status-tag [color]="card.statusColor" [label]="card.status"></app-status-tag>
            </div>
            @if (card.count !== null) {
              <p class="step-card__count">
                {{ 'Count' | translate }}: {{ card.count }}
                @if (card.activeCount !== null) {
                  <span>({{ 'Active' | translate }}: {{ card.activeCount }})</span>
                }
              </p>
            }
            @if (card.error) {
              <p class="step-card__error">{{ card.error }}</p>
            }
            @if (card.fillTarget; as fillTarget) {
              <app-primary-button title="Fill" icon="pi pi-arrow-right" (action)="fill(fillTarget)"></app-primary-button>
            }
          </li>
        }
      </ul>
    }
  }
</div>
